export const rewindSpeedControlAttribute = {
  attributeKey: 'REWIND_SPEED_CONTROLS',
  attributeValue: 'TRUE',
};
